export const pattern9Data = [
  {
    id: 1,
    koreanChunks: ["제출해 주세요", "당신의 출장비 보고서를", "이달 말에"],
    englishChunks: [
      "Please submit",
      "your travel expense report",
      "at the end of the month",
    ],
    fullEnglish:
      "Please submit your travel expense report at the end of the month.",
    explanation:
      "시간을 나타내는 전치사구 'at the end of'가 사용되었습니다. 'at the end of'는 '~의 말에'를 의미하며, 특정 기간의 끝을 나타냅니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "성수기 시간이",
      "시작됩니다",
      "정오에",
      "그리고",
      "지속됩니다",
      "오후 2시까지",
    ],
    englishChunks: [
      "The peak hours",
      "begin",
      "at noon",
      "and",
      "last",
      "until 2 PM",
    ],
    fullEnglish: "The peak hours begin at noon and last until 2 PM.",
    explanation:
      "시간을 나타내는 전치사 'at'과 'until'이 사용되었습니다. 'at'은 특정 시점을, 'until'은 '~까지'라는 종료 시점을 나타냅니다.",
    additionalExplanation:
      "여기에서는 시간이라고 해서 무조건 at 전치사가 나오지 않고 해석에 따라 달라지는 것을 볼 수 있습니다. 'at noon(정오에)'은 특정 시점을 나타내므로 at을 사용했고, 'until 2 PM(오후 2시까지)'은 지속 기간의 끝을 나타내므로 until을 사용했습니다. 전치사를 해석할때는 우선 읽기만 하고 넘어간 뒤 전치사 뒤 내용을 읽은 후 전치사의 뜻을 더합니다, 정오에, 오후2시까지 처럼 말입니다. ",
  },
  {
    id: 3,
    koreanChunks: ["사무실은", "닫혀 있습니다", "일요일과 공휴일에"],
    englishChunks: [
      "The office is",
      "closed",
      "on Sundays and public holidays",
    ],
    fullEnglish: "The office is closed on Sundays and public holidays.",
    explanation:
      "시간을 나타내는 전치사 'on'이 사용되었습니다. 'on'은 특정 요일이나 날짜를 나타낼 때 사용됩니다.",
  },
  {
    id: 4,
    koreanChunks: ["최종 프로젝트는", "마감 예정입니다", "금요일 오전에"],
    englishChunks: ["Your final project is", "due", "on Friday morning"],
    fullEnglish: "Your final project is due on Friday morning.",
    explanation:
      "시간을 나타내는 전치사 'on'이 사용되었습니다. 'on'은 특정 요일이나 날짜를 나타낼 때 사용됩니다.",
  },

  {
    id: 5,
    koreanChunks: [
      "그 회사는",
      "(과거에) 설립되었다",
      "1998년에",
      "그리고",
      "(현재) 성장했다",
      "꾸준히",
      "그 이후로",
    ],
    englishChunks: [
      "The company",
      "was founded",
      "in 1998",
      "and",
      "has grown",
      "steadily",
      "since then",
    ],
    fullEnglish:
      "The company was founded in 1998 and has grown steadily since then.",
    explanation:
      "시간을 나타내는 전치사 'in'과 'since'가 사용되었습니다. 'in'은 연도를 나타낼 때, 'since'는 '~이후로'라는 시작 시점을 나타낼 때 사용됩니다.",
    additionalExplanation:
      "'since then'은 '그 이후로'라는 의미로, 그냥 그 자체로 함께 익혀주세요. 영어에서 자주 쓰는 표현은 분리하지 않고 묶어서 암기하는 것이 좋습니다. 'since then', 'from now on(지금부터)', 'up until now(지금까지)' 등의 시간 관련 표현들은 하나의 덩어리로 외우면 실제 대화나 독해에서 더 빠르게 이해할 수 있습니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "새로운 마케팅 전략은",
      "(미래에) 시행 될 것입니다",
      "2분기에",
    ],
    englishChunks: [
      "The new marketing strategy",
      "will be implemented",
      "in the second quarter",
    ],
    fullEnglish:
      "The new marketing strategy will be implemented in the second quarter.",
    explanation:
      "시간을 나타내는 전치사 'in'이 사용되었습니다. 'in'은 특정 기간이나 분기를 나타낼 때 사용됩니다.",
  },
  {
    id: 7,
    koreanChunks: [
      "우리는 예상합니다",
      "큰 증가를",
      "수익에서",
      "향후 5년 동안",
    ],
    englishChunks: [
      "We expect",
      "a significant increase",
      "in revenue",
      "in the next five years",
    ],
    fullEnglish:
      "We expect a significant increase in revenue in the next five years.",
    explanation:
      "전치사 'in'이 두 번 사용되었습니다. 첫 번째 'in'은 '~에서의'라는 의미로, 두 번째 'in'은 기간을 나타내는 데 사용되었습니다.",
    additionalExplanation:
      "마찬가지로 전치사 부분은 일단 읽고 해석하지 않고 마지막에 붙여주세요. '우리는 기대했다 큰 증가를 수익( ) 향후 5년( )'처럼 해석한다고 보시면 됩니다. 전치사는 읽되, 뒤에 붙이는 방식으로 접근하세요. 중요한 점은 전치사의 의미를 하나로 고정하면 안 된다는 것입니다. 'in'을 무조건 '~안에'로 해석하면 이 문장이 조금 어색했을 것입니다. 첫 번째 'in'은 '~에서의'로, 두 번째 'in'은 '~동안'으로 문맥에 맞게 해석해야 합니다.",
  },
  {
    id: 8,
    koreanChunks: ["완료해 주세요", "필수 교육을", "회계연도 말 전에"],
    englishChunks: [
      "Please complete",
      "the mandatory training",
      "before the end of the fiscal year",
    ],
    fullEnglish:
      "Please complete the mandatory training before the end of the fiscal year.",
    explanation:
      "시간을 나타내는 전치사 'before'가 사용되었습니다. 'before'는 '~전에'라는 의미로 시점이나 기한을 나타냅니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "모든 지원자들은",
      "반드시 제출해야 합니다",
      "그들의 이력서들을",
      "3월 15일 이전에",
    ],
    englishChunks: [
      "All applicants",
      "must submit",
      "their resumes",
      "before March 15",
    ],
    fullEnglish: "All applicants must submit their resumes before March 15.",
    explanation:
      "시간을 나타내는 전치사 'before'가 사용되었습니다. 구체적인 날짜나 시점 이전을 나타냅니다.",
  },
  {
    id: 10,
    koreanChunks: ["결제는", "완료되어야 합니다", "배송이 처리되기 전에"],
    englishChunks: [
      "The payment",
      "should be made",
      "before the shipment is processed",
    ],
    fullEnglish: "The payment should be made before the shipment is processed.",
    explanation:
      "시간을 나타내는 전치사 'before'가 사용되었습니다. 여기서는 한 사건이 다른 사건에 선행해야 함을 나타냅니다.",
    additionalExplanation:
      "뒤에 절이 나온 것으로, 접속사입니다. 접속사뒤 주어+동사를 읽고 접속사의 의미를 더해서 읽고 넘어가면 됩니다 즉 여기서는 배송이 처리되기 전에 입니다. ~전에, 배송이 처리되기 (X)",
  },
  {
    id: 11,
    koreanChunks: ["잡아 주세요", "당신의 약속들을", "오후 2시 이후로"],
    englishChunks: ["Please schedule", "your appointments", "after 2 PM"],
    fullEnglish: "Please schedule your appointments after 2 PM.",
    explanation: "",
  },
  {
    id: 12,
    koreanChunks: [
      "직원들은",
      "(미래에) 받을 것입니다",
      "그들의 연간 보너스를",
      "재무 보고서가 완료된 후",
    ],
    englishChunks: [
      "Employees",
      "will receive",
      "their annual bonuses",
      "after the financial report is finalized",
    ],
    fullEnglish:
      "Employees will receive their annual bonuses after the financial report is finalized.",
    explanation:
      "접속사입니다 재무보고서가 완료된 후(O) ~후에 재무보고서가 완된(X)",
  },
  {
    id: 13,
    koreanChunks: ["배송은", "예상된다", "도착하도록", "다음 주 수요일까지"],
    englishChunks: [
      "The shipment",
      "is expected",
      "to arrive",
      "by next Wednesday",
    ],
    fullEnglish: "The shipment is expected to arrive by next Wednesday.",
    explanation:
      "시간을 나타내는 전치사 'by'가 사용되었습니다. 'by'는 '~까지'라는 의미로 마감 시한을 나타냅니다.",
  },
  {
    id: 14,
    koreanChunks: ["모든 송장은", "결제되어야 합니다", "이달 말까지"],
    englishChunks: ["All invoices", "must be paid", "by the end of the month"],
    fullEnglish: "All invoices must be paid by the end of the month.",
    explanation:
      "시간을 나타내는 전치사 'by'가 사용되었습니다. 'by the end of'는 '~말까지'라는 의미로 기한을 나타냅니다.",
  },
  {
    id: 15,
    koreanChunks: ["프로모션 혜택은", "유효합니다", "이달 말까지"],
    englishChunks: [
      "The promotional offer",
      "is valid",
      "until the end of the month",
    ],
    fullEnglish: "The promotional offer is valid until the end of the month.",
    explanation:
      "시간을 나타내는 전치사 'until'이 사용되었습니다. 'until'은 '~까지'라는 의미로 종료 시점을 나타냅니다.",
  },
  {
    id: 16,
    koreanChunks: ["직원들은", "요구됩니다", "남도록", "회의가 끝날 때까지"],
    englishChunks: [
      "Employees",
      "are required",
      "to stay",
      "until the meeting concludes",
    ],
    fullEnglish: "Employees are required to stay until the meeting concludes.",
    explanation:
      "시간을 나타내는 전치사 'until'이 사용되었습니다. 특정 사건이 발생할 때까지의 지속을 나타냅니다.",
  },
  {
    id: 17,
    koreanChunks: ["이 계약은", "유효할 것입니다", "추가 공지가 있을 때까지"],
    englishChunks: [
      "The contract",
      "will be in effect",
      "until further notice",
    ],
    fullEnglish: "The contract will be in effect until further notice.",
    explanation:
      "시간을 나타내는 전치사 'until'이 사용되었습니다. 'until further notice'는 '추가 공지가 있을 때까지'라는 관용구입니다.",
  },
  {
    id: 18,
    koreanChunks: ["그 회사는", "(현재) 운영 했습니다", "1985년부터"],
    englishChunks: ["The company", "has been in business", "since 1985"],
    fullEnglish: "The company has been in business since 1985.",
    explanation:
      "시간을 나타내는 전치사 'since'가 사용되었습니다. 'since'는 '~부터'라는 의미로 시작 시점을 나타냅니다.",
  },
  {
    id: 19,
    koreanChunks: [
      "매출이",
      "(현재) 증가했습니다 크게",
      "출시 이후 새로운 제품 ",
    ],
    englishChunks: [
      "Sales",
      "have increased significantly",
      "since the launch of the new product",
    ],
    fullEnglish:
      "Sales have increased significantly since the launch of the new product.",
    explanation:
      "시간을 나타내는 전치사 'since'가 사용되었습니다. 특정 사건 이후부터 현재까지의 상황을 나타냅니다.",
  },
  {
    id: 20,
    koreanChunks: ["그는 (현재) 있습니다", "그 회사에서", "10년 넘게"],
    englishChunks: ["He has been", "with the company", "for over 10 years"],
    fullEnglish: "He has been with the company for over 10 years.",
    explanation:
      "기간을 나타내는 전치사 'for'가 사용되었습니다. 'for'는 지속 기간을 나타냅니다.",
  },
  {
    id: 21,
    koreanChunks: ["CEO는 (현재) 있습니다", "출장에", "일주일 동안"],
    englishChunks: ["The CEO has been", "on a business trip", "for a week"],
    fullEnglish: "The CEO has been on a business trip for a week.",
    explanation:
      "기간을 나타내는 전치사 'for'가 사용되었습니다. 현재까지 지속된 기간을 나타냅니다.",
  },
  {
    id: 22,
    koreanChunks: [
      "CEO는 (미래에) 있을 것입니다",
      "메인 컨퍼런스 홀에",
      "기조 연설을 위해",
    ],
    englishChunks: [
      "The CEO will be",
      "at the main conference hall",
      "for the keynote speech",
    ],
    fullEnglish:
      "The CEO will be at the main conference hall for the keynote speech.",
    explanation:
      "장소를 나타내는 전치사 'at'과 목적을 나타내는 전치사 'for'가 사용되었습니다. 'at'은 특정 장소를, 'for'는 목적이나 용도를 나타냅니다.",
  },
  {
    id: 23,
    koreanChunks: ["지정된 주차 구역이 있습니다", "뒷문 쪽에"],
    englishChunks: [
      "There is a designated parking area",
      "at the back entrance",
    ],
    fullEnglish: "There is a designated parking area at the back entrance.",
    explanation:
      "장소를 나타내는 전치사 'at'이 사용되었습니다. 'at'은 특정 위치나 지점을 나타냅니다.",
  },
  {
    id: 24,
    koreanChunks: ["놓아주세요 당신의 짐을", "머리 위 수납칸에"],
    englishChunks: ["Place your belongings", "on the overhead compartment"],
    fullEnglish: "Please place your belongings on the overhead compartment.",
    explanation:
      "장소를 나타내는 전치사 'on'이 사용되었습니다. 'on'은 표면이나 위치를 나타냅니다.",
  },
  {
    id: 25,
    koreanChunks: ["모든 문서들", "확인할 수 있습니다", "회사 웹사이트에서"],
    englishChunks: ["All documents", "are available", "on the company website"],
    fullEnglish: "All documents are available on the company website.",
    explanation:
      "장소를 나타내는 전치사 'on'이 사용되었습니다. 웹사이트나 온라인 플랫폼을 지칭할 때 'on'을 사용합니다.",
  },
  {
    id: 26,
    koreanChunks: ["회의는", "진행 중입니다", "메인 회의실에서"],
    englishChunks: [
      "The meeting",
      "is being held",
      "in the main conference room",
    ],
    fullEnglish: "The meeting is being held in the main conference room.",
    explanation:
      "장소를 나타내는 전치사 'in'이 사용되었습니다. 'in'은 enclosed space(폐쇄된 공간)를 나타낼 때 사용됩니다.",
  },
  {
    id: 27,
    koreanChunks: [
      "모든 기밀 파일은",
      "저장되어 있습니다",
      "보안 데이터베이스에",
    ],
    englishChunks: [
      "All confidential files",
      "are stored",
      "in the secure database",
    ],
    fullEnglish: "All confidential files are stored in the secure database.",
    explanation:
      "장소를 나타내는 전치사 'in'이 사용되었습니다. 데이터베이스와 같은 시스템이나 저장소를 지칭할 때 'in'을 사용합니다.",
  },
  {
    id: 28,
    koreanChunks: [
      "프린터는",
      "배치되어 있습니다",
      "출입구 근처에",
      "쉽게 접근할 수 있도록",
    ],
    englishChunks: [
      "The printer",
      "is located",
      "by the entrance",
      "for easy access",
    ],
    fullEnglish: "The printer is located by the entrance for easy access.",
    explanation:
      "위치를 나타내는 전치사 'by'가 사용되었습니다. 'by'는 '~근처에', '~옆에'의 의미로 사용됩니다.",
  },
  {
    id: 29,
    koreanChunks: [
      "고객은",
      "앉았습니다.",
      "프로젝트 매니저 옆에",
      "발표 중에",
    ],
    englishChunks: [
      "The client",
      "sat",
      "beside the project manager",
      "during the presentation",
    ],
    fullEnglish:
      "The client sat beside the project manager during the presentation.",
    explanation:
      "위치를 나타내는 전치사 'beside'가 사용되었고, 시간을 나타내는 전치사 'during'이 함께 사용되었습니다. 'beside'는 '~옆에'를, 'during'은 '~동안'을 의미합니다.",
  },
  {
    id: 30,
    koreanChunks: ["회사 로고가", "표시되어 있습니다", "입구 위에"],
    englishChunks: ["The company logo", "is displayed", "over the entrance"],
    fullEnglish: "The company logo is displayed over the entrance.",
    explanation:
      "위치를 나타내는 전치사 'over'가 사용되었습니다. 'over'는 '~위에'의 의미로, 특히 무언가가 다른 것의 위쪽에 있음을 나타냅니다.",
  },
  {
    id: 31,
    koreanChunks: ["보안 카메라가", "설치되어 있습니다", "주차 구역 위에"],
    englishChunks: [
      "Security cameras",
      "are installed",
      "over the parking area",
    ],
    fullEnglish: "Security cameras are installed over the parking area.",
    explanation:
      "위치를 나타내는 전치사 'over'가 사용되었습니다. 이 문장에서도 'over'는 보안 카메라가 주차 구역의 위쪽에 설치되어 있음을 나타냅니다.",
  },
  {
    id: 32,
    koreanChunks: ["회사의 실적이 있습니다.", "더 업계 평균 위에."],
    englishChunks: [
      "The company's performance is",
      "well above the industry average",
    ],
    fullEnglish:
      "The company's performance is well above the industry average.",
    explanation:
      "위치나 수준을 나타내는 전치사 'above'가 사용되었습니다. 'above'는 '~보다 위에', '~을 상회하는'의 의미로 사용되며, 'well'이 함께 쓰여 '훨씬'이라는 의미를 더합니다.",
    additionalExplanation:
      "'well above'는 '훨씬 위에', '크게 상회하는'이라는 의미의 표현으로, 비즈니스 영어에서 자주 사용되는 관용구입니다. 'above'만 사용하면 단순히 '~보다 위에'라는 의미지만, 'well'이 부사로 추가되면 그 정도가 상당함을 강조합니다. 이런 표현은 'well below(훨씬 아래)', 'well beyond(훨씬 너머)', 'well within(충분히 ~이내)' 등과 같은 패턴으로도 자주 사용됩니다. 이러한 표현들은 하나의 덩어리로 익혀두면 비즈니스 문서나 보고서를 읽을 때 빠르게 이해할 수 있습니다.",
  },
  {
    id: 33,
    koreanChunks: ["간판이", "배치되어 있습니다", "입구 위에", "가시성을 위해"],
    englishChunks: [
      "The signboard",
      "is positioned",
      "above the entrance",
      "for visibility",
    ],
    fullEnglish:
      "The signboard is positioned above the entrance for visibility.",
    explanation:
      "위치를 나타내는 전치사 'above'가 사용되었고, 목적을 나타내는 전치사 'for'가 함께 사용되었습니다. 'above'는 '~위에'를, 'for'는 '~을 위해'를 의미합니다.",
  },
  {
    id: 34,
    koreanChunks: ["문서들은", "보관됩니다", "잠긴 캐비닛 안에"],
    englishChunks: ["The documents", "are kept", "inside the locked cabinet"],
    fullEnglish: "The documents are kept inside the locked cabinet.",
    explanation:
      "위치를 나타내는 전치사 'inside'가 사용되었습니다. 'inside'는 '~안에'라는 의미로, 무언가가 어떤 공간이나 물체의 내부에 있음을 나타냅니다.",
  },
  {
    id: 35,
    koreanChunks: ["보내주세요", "모든 고객 문의들을", "지원팀으로"],
    englishChunks: [
      "Please direct",
      "all customer inquiries",
      "to the support team",
    ],
    fullEnglish: "Please direct all customer inquiries to the support team.",
    explanation:
      "방향을 나타내는 전치사 'to'가 사용되었습니다. 'to'는 '~로', '~에게'의 의미로 목적지나 수신자를 나타냅니다.",
  },
  {
    id: 36,
    koreanChunks: [
      "회사는",
      "나아가고 있습니다",
      "더 지속 가능한 비즈니스 모델을 향해",
    ],
    englishChunks: [
      "The company",
      "is moving",
      "towards a more sustainable business model",
    ],
    fullEnglish:
      "The company is moving towards a more sustainable business model.",
    explanation:
      "방향을 나타내는 전치사 'towards'가 사용되었습니다. 'towards'는 '~을 향하여', '~쪽으로'의 의미로 어떤 목표나 방향을 향한 움직임을 나타냅니다.",
  },
  {
    id: 37,
    koreanChunks: [
      "직원들은",
      "긁어야 합니다",
      "ID 카드를",
      "시스템에",
      "출입을 위해",
    ],
    englishChunks: [
      "Employees",
      "must swipe",
      "their ID cards",
      "into the system",
      "for entry",
    ],
    fullEnglish:
      "Employees must swipe their ID cards into the system for entry.",
    explanation:
      "방향을 나타내는 전치사 'into'와 목적을 나타내는 전치사 'for'가 사용되었습니다. 'into'는 '~안으로', '~에'를 의미하고, 'for'는 '~을 위해'를 의미합니다.",
  },
  {
    id: 38,
    koreanChunks: ["배송 트럭이", "후진했습니다", "하역장 안으로"],
    englishChunks: ["The delivery truck", "backed", "into the loading dock"],
    fullEnglish: "The delivery truck backed into the loading dock.",
    explanation:
      "방향을 나타내는 전치사 'into'가 사용되었습니다. 'into'는 '~안으로', '~로'의 의미로 어떤 공간이나 장소로 들어가는 움직임을 나타냅니다.",
  },
  {
    id: 39,
    koreanChunks: [
      "직원이",
      "실수로",
      "쳐서 떨어뜨렸다",
      "문서를",
      "테이블에서",
    ],
    englishChunks: [
      "The employee",
      "accidentally",
      "knocked",
      "the documents",
      "off the table",
    ],
    fullEnglish:
      "The employee accidentally knocked the documents off the table.",
    explanation:
      "방향을 나타내는 전치사 'off'가 사용되었습니다. 'off'는 '~에서 떨어져서', '~로부터 멀어져'의 의미로 어떤 것이 표면이나 위치에서 분리되는 것을 나타냅니다.",
    additionalExplanation:
      "'off'는 '~에서 떨어져', '~로부터 멀어져'라는 의미의 전치사로, 특히 물체가 원래 있던 위치나 표면에서 분리되는 상황을 표현할 때 사용됩니다. 이 문장에서 'knocked off'는 '쳐서 떨어뜨렸다'라는 의미로, 동사 'knock'과 전치사 'off'가 결합하여 하나의 동작을 표현합니다. 이런 동사+전치사 조합은 영어에서 매우 흔하며, 'fall off(떨어지다)', 'take off(벗다, 이륙하다)', 'get off(내리다)' 등 다양한 표현이 있습니다. 이러한 구문을 해석할 때는 '테이블(에서) 떨어뜨렸다'와 같이 전치사의 의미를 문맥에 맞게 자연스럽게 연결하는 것이 중요합니다.",
  },
  {
    id: 40,
    koreanChunks: ["회사는", "발표했습니다", "정책 변경을", "이메일을 통해"],
    englishChunks: [
      "The company",
      "announced",
      "the policy change",
      "by email",
    ],
    fullEnglish: "The company announced the policy change by email.",
    explanation:
      "수단이나 방법을 나타내는 전치사 'by'가 사용되었습니다. 'by'는 '~을 통해', '~로'의 의미로 어떤 일을 수행하는 방법이나 수단을 나타냅니다.",
  },
  {
    id: 41,
    koreanChunks: ["저어 주세요", "용액을", "나무 막대로", "사용 전에"],
    englishChunks: [
      "Stir",
      "the solution",
      "with a wooden stick",
      "before use",
    ],
    fullEnglish: "Please stir the solution with a wooden stick before use.",
    explanation:
      "도구를 나타내는 전치사 'with'와 시간을 나타내는 전치사 'before'가 사용되었습니다. 'with'는 '~로', '~을 가지고'의 의미로 도구나 수단을 나타내고, 'before'는 '~전에'의 의미로 시간적 순서를 나타냅니다.",
  },
  {
    id: 42,
    koreanChunks: ["회의록은", "기록되어야 합니다", "체계적인 형식으로"],
    englishChunks: [
      "The meeting minutes",
      "must be recorded",
      "in a structured format",
    ],
    fullEnglish: "The meeting minutes must be recorded in a structured format.",
    explanation:
      "방법이나 형태를 나타내는 전치사 'in'이 사용되었습니다. 'in'은 '~로', '~의 형태로'의 의미로 어떤 것의 상태나 형식을 나타냅니다.",
  },
  {
    id: 43,
    koreanChunks: [
      "웨비나는",
      "스트리밍될 것입니다",
      "실시간으로",
      "회사 공식 웹사이트에서",
    ],
    englishChunks: [
      "The webinar",
      "will be streamed",
      "live",
      "on the company's official website",
    ],
    fullEnglish:
      "The webinar will be streamed live on the company's official website.",
    explanation:
      "장소나 위치를 나타내는 전치사 'on'이 사용되었습니다. 'on'은 '~에서', '~위에'의 의미로 특히 웹사이트나 플랫폼을 지칭할 때 자주 사용됩니다.",
  },
  {
    id: 44,
    koreanChunks: [
      "CEO가",
      "세계 유수의 기술 회사 중 한 곳",
      "기조연설할 것이다",
      "컨퍼런스에서",
    ],
    englishChunks: [
      "The CEO",
      "of one of the world's leading technology companies",
      "will deliver the keynote speech",
      "at the conference",
    ],
    fullEnglish:
      "The CEO of one of the world's leading technology companies will deliver the keynote speech at the conference.",
    explanation:
      "장소를 나타내는 전치사 'at'이 사용되었습니다. 'at'은 '~에서'의 의미로 특정 장소나 이벤트를 지칭할 때 사용됩니다.",
    additionalExplanation:
      "'of'를 소유격으로 '~의'로 해석해서 뒤에서 앞으로 다시 해석하는 한국어 순으로 해석하지 않도록 합니다. 'of'는 보충 개념, 바로 앞의 내용을 좀 더 보충하는 느낌으로만 갑니다. 그냥 한번 운을 떼고 설명을 보충받는다고 생각해보세요. 다음 동사와 이어지는 것이 아닙니다. '~의'로 해석해서 괜히 주어를 너무 길게 만들지 마세요. 이 문장에서는 'The CEO(CEO가)'가 주어이고, 'of one of the world's leading technology companies(세계 유수의 기술 회사 중 한 곳)'는 CEO에 대한 부가 설명일 뿐입니다. 이렇게 해석하면 문장의 핵심 구조를 더 명확하게 파악할 수 있습니다.",
  },
  {
    id: 45,
    koreanChunks: [
      "성능이",
      "새로 개발된 소프트웨어",
      "평가될 것입니다",
      "사용자 피드백과 시스템 안정성을 기준으로",
    ],
    englishChunks: [
      "The performance",
      "of the newly developed software",
      "will be evaluated",
      "based on user feedback and system stability",
    ],
    fullEnglish:
      "The performance of the newly developed software will be evaluated based on user feedback and system stability.",
    explanation:
      "기준이나 근거를 나타내는 표현 'based on'이 사용되었습니다. 'based on'은 '~을 기준으로', '~에 근거하여'의 의미로 평가나 판단의 기준을 나타냅니다.",
  },
  {
    id: 46,
    koreanChunks: [
      "세부 사항이",
      "다가오는 기업 구조조정 계획 ",
      "발표될 것입니다",
      "분기별 이사회 회의에서",
    ],
    englishChunks: [
      "The details",
      "of the upcoming corporate restructuring plan",
      "will be announced",
      "during the quarterly board meeting",
    ],
    fullEnglish:
      "The details of the upcoming corporate restructuring plan will be announced during the quarterly board meeting.",
    explanation:
      "시간을 나타내는 전치사 'during'이 사용되었습니다. 'during'은 '~동안', '~중에'의 의미로 어떤 일이 발생하는 시간이나 기간을 나타냅니다.",
  },
  {
    id: 47,
    koreanChunks: [
      "마감일은",

      "제출을 위한 비용보고서를",
      "다음 주 월요일입니다",
    ],
    englishChunks: [
      "The deadline",
      "for submitting expense reports",
      "is next Monday",
    ],
    fullEnglish: "The deadline for submitting expense reports is next Monday.",
    explanation:
      "목적을 나타내는 전치사 'for'가 사용되었습니다. 'for'는 '~을 위한', '~의 목적으로'라는 의미로 어떤 행위나 물건의 목적이나 용도를 설명할 때 사용됩니다.",
  },
  {
    id: 48,
    koreanChunks: [
      "교육 프로그램이",
      "신입 직원을 위한",
      "열릴 예정입니다",
      "다음 주에",
    ],
    englishChunks: [
      "A training program",
      "for new employees",
      "will be held",
      "next week",
    ],
    fullEnglish: "A training program for new employees will be held next week.",
    explanation:
      "대상이나 목적을 나타내는 전치사 'for'가 사용되었습니다. 여기서는 교육 프로그램의 대상이 되는 '신입 직원들'을 지정하는데 사용되었습니다.",
  },
  {
    id: 49,
    koreanChunks: [
      "이 소프트웨어는",
      "설계되었습니다",
      "관리를 위해 대규모 데이터를 효율적으로 ",
    ],
    englishChunks: [
      "This software",
      "is designed",
      "for managing large-scale data efficiently",
    ],
    fullEnglish:
      "This software is designed for managing large-scale data efficiently.",
    explanation:
      "목적을 나타내는 전치사 'for'가 사용되었습니다. 동명사(managing)와 함께 사용되어 소프트웨어의 설계 목적을 나타냅니다.",
  },
  {
    id: 50,
    koreanChunks: [" ", "반영될 것입니다", "회사의 연간 재무 보고서에"],
    englishChunks: [
      "The effectiveness of the cost-cutting measures",
      "will be reflected",
      "in the company's annual financial report",
    ],
    fullEnglish:
      "The effectiveness of the cost-cutting measures will be reflected in the company's annual financial report.",
    explanation:
      "전치사 'in'이 사용되어 어떤 것이 포함되거나 표현되는 장소나 매체를 나타냅니다. 여기서는 효과가 '반영되는' 문서나 매체를 지정하는데 사용되었습니다.",
  },
  {
    id: 51,
    koreanChunks: [
      "정책변경의 영향이",
      "사업운영에 미치는",
      "평가될 것입니다",
      "다음 분기에",
    ],
    englishChunks: [
      "The impact of the policy change",
      " on business operations",
      "will be assessed",
      "next quarter",
    ],
    fullEnglish:
      "The impact of the policy change on business operations will be assessed next quarter.",
    explanation:
      "전치사 'on'이 사용되어 영향이나 효과가 미치는 대상을 나타냅니다. 여기서는 정책 변경이 영향을 미치는 대상인 '사업 운영'을 지정하는데 사용되었습니다.",
  },
  {
    id: 52,
    koreanChunks: [
      "지역 주민들은",
      "반대 시위를 했습니다",
      "건설에 새로운 공장",
    ],
    englishChunks: [
      "Local residents",
      "protested",
      "against the construction of the new factory",
    ],
    fullEnglish:
      "Local residents protested against the construction of the new factory.",
    explanation:
      "전치사 'against'가 사용되어 반대나 저항의 대상을 나타냅니다. 여기서는 주민들이 반대하는 대상인 '새로운 공장의 건설'을 지정하는데 사용되었습니다.",
  },
  {
    id: 53,
    koreanChunks: [
      "그 프로젝트는",
      "초과했다",
      "기대를",
      "그리고 제공했다 결과를",
      "초기 예상보다 더 넘는 수준의",
    ],
    englishChunks: [
      "The project",
      "exceeded ",
      "expectations",
      "and delivered results",
      "beyond initial projections",
    ],
    fullEnglish:
      "The project exceeded expectations and delivered results beyond initial projections.",
    explanation:
      "전치사 'beyond'가 사용되어 어떤 한계나 수준을 넘어섬을 나타냅니다. 여기서는 결과가 '초기 예상'이라는 기준을 넘어섰다는 것을 표현하는데 사용되었습니다.",
  },
  {
    id: 54,
    koreanChunks: ["승인 즉시,", "계약서가", "보내질 것입니다", "서명을 위해"],
    englishChunks: [
      "Upon approva,",
      "the contract",
      "will be sent",
      "for signature",
    ],
    fullEnglish: "Upon approval, the contract will be sent for signature.",
    explanation:
      "전치사 'upon'과 'for'가 사용되었습니다. 'upon'은 '~하자마자, ~즉시'의 의미로 시점을 나타내고, 'for'는 목적이나 용도를 나타내는데 사용되었습니다.",
  },
  {
    id: 55,
    koreanChunks: [
      "경쟁업체들과 달리,",
      "이 회사는",
      "중점을 둡니다",
      "우수한 고객 서비스에",
    ],
    englishChunks: [
      "Unlike its competitors,",
      "the company",
      "focuses",
      "on customer service excellence",
    ],
    fullEnglish:
      "Unlike its competitors, the company focuses on customer service excellence.",
    explanation:
      "전치사 'unlike'와 'on'이 사용되었습니다. 'unlike'는 '~와 달리'라는 의미로 비교나 대조를 나타내고, 'on'은 '~에'라는 의미로 집중이나 중점의 대상을 나타내는데 사용되었습니다.",
  },
  {
    id: 56,
    koreanChunks: [
      "당신은 일찍 퇴근할 수 있습니다",
      "완료한다는 조건으로",
      "당신의 업무를",
    ],
    englishChunks: [
      "You may leave early",
      "provided that you complete",
      "your tasks",
    ],
    fullEnglish: "You may leave early provided that you complete your tasks.",
    explanation:
      "접속사구 'provided that'은 '~한다는 조건으로'라는 의미로 조건을 나타내는데 사용됩니다. 이는 'if' 또는 'on condition that'와 비슷한 의미로 사용되며, 공식적인 상황에서 조건을 제시할 때 자주 사용됩니다.",
    additionalExplanation:
      "뒤에 절이 있어 접속사처럼 해석합니다 S+V+접속사 이렇게 해석합니다.",
  },
  {
    id: 57,
    koreanChunks: [
      "새로운 제품이 혁신적임에도 불구하고,",
      "그 제품의 시장 잠재력은",
      "불확실합니다",
    ],
    englishChunks: [
      "While the new product is innovative,",
      "its market potential",
      "is uncertain",
    ],
    fullEnglish:
      "While the new product is innovative, its market potential is uncertain.",
    explanation:
      "접속사 'while'이 양보의 의미로 사용되었습니다. 'while'은 '~임에도 불구하고'라는 의미로 두 개의 대조되는 상황을 연결할 때 사용됩니다. 첫 번째 절은 긍정적인 측면(혁신적)을 나타내고, 두 번째 절은 부정적인 측면(불확실성)을 나타냅니다.",
    additionalExplanation: "S+V 접속사 = 새로운 제품이 혁신적임에도 불구하고'",
  },
  {
    id: 58,
    koreanChunks: [
      "회사가",
      "실패했다",
      "맞추는걸",
      "마감일을;",
      "따라서,",
      "그 계약이 취소되었습니다",
    ],
    englishChunks: [
      "The company",
      "failed",
      "to meet",
      "the deadline;",
      "consequently,",
      "the contract was canceled",
    ],
    fullEnglish:
      "The company failed to meet the deadline; consequently, the contract was canceled.",
    explanation:
      "접속부사 'consequently'가 사용되었습니다. 'consequently'는 '그 결과로, 따라서'라는 의미로 원인과 결과를 연결할 때 사용됩니다. 첫 번째 문장은 원인(마감일을 맞추지 못함)을 나타내고, 두 번째 문장은 그로 인한 결과(계약 취소)를 나타냅니다.",
    additionalExplanation: "접속부사는 부사처럼 해석합니다.",
  },
  {
    id: 59,
    koreanChunks: [
      "새로운 세금 정책이",
      "시행되었습니다;",
      "따라서",
      "기업들은 반드시 조정해야 합니다",
      "가격 전략을",
    ],
    englishChunks: [
      "The new tax policy",
      "has been implemented;",
      "accordingly,",
      "businesses must adjust",
      "their pricing strategies",
    ],
    fullEnglish:
      "The new tax policy has been implemented; accordingly, businesses must adjust their pricing strategies.",
    explanation:
      "접속부사 'accordingly'가 사용되었습니다. 'accordingly'는 '따라서, 그에 따라'라는 의미로 원인과 결과를 연결할 때 사용됩니다. 첫 번째 문장은 원인(새로운 세금 정책 시행)을 나타내고, 두 번째 문장에서는 그로 인한 결과(가격 전략 조정의 필요성)를 나타냅니다.",
  },
  {
    id: 60,
    koreanChunks: [
      "이전 모델은",
      "가졌다 짧은 배터리 수명을,",
      "대조적으로,",
      "새로운 버전은 지속됩니다 훨씬 오래 ",
    ],
    englishChunks: [
      "The previous model",
      "had poor battery life;",
      "in contrast,",
      "the new version lasts much longer",
    ],
    fullEnglish:
      "The previous model had poor battery life; in contrast, the new version lasts much longer.",
    explanation:
      "접속부사 'in contrast'가 사용되었습니다. 'in contrast'는 '대조적으로'라는 의미로 두 상황 간의 뚜렷한 차이를 나타낼 때 사용됩니다. 첫 번째 문장은 이전 모델의 단점(짧은 배터리 수명)을 나타내고, 두 번째 문장은 새 모델의 장점(긴 배터리 수명)을 대조적으로 보여줍니다.",
  },
  {
    id: 61,
    koreanChunks: [
      "세 명의 직원이",
      "승진했습니다;",
      "다시말해,",
      "John, Sarah, 그리고 David입니다",
    ],
    englishChunks: [
      "Three employees",
      "were promoted;",
      "namely,",
      "John, Sarah, and David",
    ],
    fullEnglish:
      "Three employees were promoted; namely, John, Sarah, and David.",
    explanation:
      "접속부사 'namely'가 사용되었습니다. 'namely'는 '즉, 다시 말해서'라는 의미로 앞서 언급된 내용을 구체적으로 설명하거나 예시를 들 때 사용됩니다. 첫 번째 문장은 일반적인 설명(세 명의 직원 승진)을 하고, 두 번째 부분에서는 구체적인 예시(John, Sarah, David)를 제시합니다.",
  },
  {
    id: 62,
    koreanChunks: [
      "그 팀은",
      "수행했습니다 매우 훌륭하게;",
      "사실상,",
      "그들은 뛰어넘었습니다",
      "모든 기대를",
    ],
    englishChunks: [
      "The team",
      "performed exceptionally well;",
      "indeed,",
      "they exceeded",
      "all expectations",
    ],
    fullEnglish:
      "The team performed exceptionally well; indeed, they exceeded all expectations.",
    explanation:
      "접속부사 'indeed'가 사용되었습니다. 'indeed'는 '사실상, 실제로'라는 의미로 앞선 문장의 내용을 강조하거나 부연 설명할 때 사용됩니다. 첫 번째 문장은 팀의 훌륭한 성과를 언급하고, 두 번째 문장에서는 그 성과가 얼마나 뛰어났는지를 구체적으로 강조합니다.",
  },
  {
    id: 63,
    koreanChunks: [
      "새로운 정책이",
      "가져올 것입니다 변화를;",
      "확실히,",
      "향상시킬 것입니다",
      "생산성을",
    ],
    englishChunks: [
      "The new policy",
      "will bring changes;",
      "certainly,",
      "it will improve",
      "productivity",
    ],
    fullEnglish:
      "The new policy will bring changes; certainly, it will improve productivity.",
    explanation:
      "접속부사 'certainly'가 사용되었습니다. 'certainly'는 '확실히, 분명히'라는 의미로 앞선 문장의 내용에 대한 확신이나 강조를 나타낼 때 사용됩니다. 첫 번째 문장은 새로운 정책으로 인한 변화를 언급하고, 두 번째 문장에서는 그 변화가 가져올 긍정적인 결과를 확신있게 설명합니다.",
  },
  {
    id: 64,
    koreanChunks: [
      "상황이",
      "어려웠습니다;",
      "그럼에도 불구하고,",
      "우리는 찾았습니다",
      "해결할 방법을",
    ],
    englishChunks: [
      "The situation",
      "was difficult;",
      "still,",
      "we found",
      "a way to resolve it",
    ],
    fullEnglish:
      "The situation was difficult; still, we found a way to resolve it.",
    explanation:
      "접속부사 'still'이 사용되었습니다. 'still'은 '그럼에도 불구하고'라는 의미로 앞선 문장의 내용과 대조되는 내용을 이어갈 때 사용됩니다. 첫 번째 문장은 어려운 상황을 설명하고, 두 번째 문장에서는 그러한 어려움에도 불구하고 해결책을 찾았다는 긍정적인 결과를 보여줍니다.",
  },
  {
    id: 65,
    koreanChunks: [
      "새로운 기술이",
      "효율적입니다;",
      "예를 들면,",
      "그 기술은 감소시킵니다",
      "처리 시간을",
      "50%만큼",
    ],
    englishChunks: [
      "The new technology",
      "is efficient;",
      "to illustrate,",
      "it reduces",
      "processing time",
      "by 50%",
    ],
    fullEnglish:
      "The new technology is efficient; to illustrate, it reduces processing time by 50%.",
    explanation:
      "접속부사 'to illustrate'가 사용되었습니다. 'to illustrate'는 '예를 들면'이라는 의미로 앞선 문장의 내용을 구체적인 예시를 들어 설명할 때 사용됩니다. 첫 번째 문장은 새로운 기술의 효율성을 언급하고, 두 번째 문장에서는 그 효율성을 구체적인 수치로 설명합니다.",
  },
  {
    id: 66,
    koreanChunks: [
      "회사는",
      "중요시합니다 많은 것들을 ;",
      "무엇보다도,",
      "고객 만족이",
      "우선순위입니다",
    ],
    englishChunks: [
      "The company",
      "values many things;",
      "above all,",
      "customer satisfaction",
      "is the priority",
    ],
    fullEnglish:
      "The company values many things; above all, customer satisfaction is the priority.",
    explanation:
      "접속부사 'above all'이 사용되었습니다. 'above all'은 '무엇보다도'라는 의미로 여러 가지 중에서 가장 중요한 것을 강조할 때 사용됩니다. 첫 번째 문장은 회사가 여러 가치를 중요시한다는 것을 언급하고, 두 번째 문장에서는 그 중에서도 고객 만족이 가장 중요하다는 것을 강조합니다.",
  },
  {
    id: 67,
    koreanChunks: [
      "만약 공급업체가 (현재) 배송할 수 없다면 제시간에,",
      "그런 경우에는,",
      "우리는 필요할 것입니다",
      "대체 계획을",
    ],
    englishChunks: [
      "If the supplier cannot deliver on time,",
      "in that case,",
      "we will need",
      "a backup plan",
    ],
    fullEnglish:
      "If the supplier cannot deliver on time, in that case, we will need a backup plan.",
    explanation:
      "접속부사 'in that case'가 사용되었습니다. 'in that case'는 '그런 경우에는'이라는 의미로 앞서 언급된 특정 상황에서의 결과나 대응을 설명할 때 사용됩니다. 첫 번째 절은 가정법으로 공급업체가 제시간에 납품하지 못하는 상황을 설명하고, 두 번째 절에서는 그러한 상황에서 취해야 할 조치를 설명합니다.",
  },
  {
    id: 68,
    koreanChunks: [
      "제안이",
      "승인되었습니다;",
      "그 후에,",
      "프로젝트가",
      "시작되었습니다",
    ],
    englishChunks: [
      "The proposal",
      "was approved;",
      "subsequently,",
      "the project",
      "started",
    ],
    fullEnglish:
      "The proposal was approved; subsequently, the project started.",
    explanation:
      "접속부사 'subsequently'가 사용되었습니다. 'subsequently'는 '그 후에'라는 의미로 어떤 사건이나 상황이 발생한 후에 이어서 일어난 일을 설명할 때 사용됩니다. 첫 번째 문장은 제안이 승인되었다는 사실을 언급하고, 두 번째 문장에서는 그 결과로 이어진 프로젝트 시작을 설명합니다.",
  },
  {
    id: 69,
    koreanChunks: [
      "회사는",
      "확장 중입니다",
      "세 개의 주요 시장으로,",
      "즉,",
      "북미, 유럽, 그리고 아시아로",
    ],
    englishChunks: [
      "The company",
      "is expanding",
      "into three major markets,",
      "namely,",
      "North America, Europe, and Asia",
    ],
    fullEnglish:
      "The company is expanding into three major markets, namely, North America, Europe, and Asia.",
    explanation:
      "접속부사 'namely'가 사용되었습니다. 'namely'는 '즉, 다시 말해서'라는 의미로 앞서 언급된 내용을 구체적으로 설명하거나 예시를 들 때 사용됩니다. 첫 부분에서는 회사가 세 개의 주요 시장으로 확장한다는 일반적인 설명을 하고, 'namely' 이후에 구체적으로 어떤 시장들인지 열거합니다.",
  },
  {
    id: 70,
    koreanChunks: [
      "우리 회사는",
      "투자할 예정입니다",
      "지속 가능한 에너지원에,",
      "즉,",
      "태양광, 풍력, 그리고 바이오 연료입니다",
    ],
    englishChunks: [
      "Our company",
      "will invest",
      "in sustainable energy sources,",
      "namely,",
      "solar power, wind energy, and biofuels",
    ],
    fullEnglish:
      "Our company will invest in sustainable energy sources, namely, solar power, wind energy, and biofuels.",
    explanation:
      "접속부사 'namely'가 사용되었습니다. 'namely'는 '즉, 다시 말해서'라는 의미로 앞서 언급된 내용을 구체적으로 설명하거나 예시를 들 때 사용됩니다. 첫 부분에서는 회사가 지속 가능한 에너지원에 투자할 것이라는 일반적인 설명을 하고, 'namely' 이후에 구체적으로 어떤 에너지원들인지 열거합니다.",
  },
  {
    id: 71,
    koreanChunks: ["매출이", "증가했습니다", "20%만큼", "지난해 대비"],
    englishChunks: ["Sales", "increased", "by 20%", "compared to last year"],
    fullEnglish: "Sales increased by 20% compared to last year.",
    explanation:
      "비교를 나타내는 표현 'compared to'가 사용되었습니다. 'compared to'는 '~와 비교하여'라는 의미로 두 대상을 비교할 때 사용됩니다. 이 문장에서는 현재 매출을 지난해와 비교하여 20% 증가했다는 것을 설명합니다.",
  },
  {
    id: 72,
    koreanChunks: ["새로운 정책은", "시행될 것입니다", "조직 전체에 걸쳐"],
    englishChunks: [
      "The new policy",
      "will be implemented",
      "throughout the organization",
    ],
    fullEnglish:
      "The new policy will be implemented throughout the organization.",
    explanation:
      "전치사 'throughout'가 사용되었습니다. 'throughout'는 '~전체에 걸쳐', '~전반에 걸쳐'라는 의미로 어떤 것이 전체 영역이나 기간에 걸쳐 있음을 나타냅니다. 이 문장에서는 새로운 정책이 조직의 모든 부분에서 시행될 것임을 나타냅니다.",
  },
  {
    id: 73,
    koreanChunks: ["많은 비가", "내렸습니다", "한 달 내내"],
    englishChunks: ["Heavy rainfall", "occurred", "throughout the month"],
    fullEnglish: "There was heavy rainfall throughout the month.",
    explanation:
      "전치사 'throughout'가 사용되었습니다. 'throughout'는 '~내내', '~전체에 걸쳐'라는 의미로 어떤 일이나 상태가 전체 기간 동안 지속됨을 나타냅니다. 이 문장에서는 비가 한 달이라는 기간 전체에 걸쳐 내렸음을 표현합니다.",
  },
  {
    id: 74,
    koreanChunks: ["그는", "얻었습니다", "그 직업을", "채용 대행사를 통해"],
    englishChunks: ["He", "got", "the job", "through a recruitment agency"],
    fullEnglish: "He got the job through a recruitment agency.",
    explanation:
      "수단이나 경로를 나타내는 전치사 'through'가 사용되었습니다. 'through'는 '~을 통해', '~을 거쳐'라는 의미로 어떤 목적을 달성하기 위한 수단이나 경로를 나타냅니다. 이 문장에서는 직업을 구하는 과정에서 채용 대행사라는 중개자를 통했다는 것을 표현합니다.",
  },
  {
    id: 75,
    koreanChunks: ["그 소포는", "보내졌습니다", "특급 배송을 통해"],
    englishChunks: ["The package", "was sent", "via express delivery"],
    fullEnglish: "The package was sent via express delivery.",
    explanation:
      "수단이나 방법을 나타내는 전치사 'via'가 사용되었습니다. 'via'는 '~을 통해', '~을 거쳐'라는 의미로 특히 운송, 전달, 통신의 경로나 수단을 나타낼 때 사용됩니다. 이 문장에서는 소포가 발송된 배송 방식을 나타냅니다.",
  },
  {
    id: 76,
    koreanChunks: [
      "당신은",
      "접근할 수 있습니다",
      "보고서에",
      "회사의 내부 네트워크를 통해",
    ],
    englishChunks: [
      "You",
      "can access",
      "the report",
      "via the company's internal network",
    ],
    fullEnglish:
      "You can access the report via the company's internal network.",
    explanation:
      "수단이나 경로를 나타내는 전치사 'via'가 사용되었습니다. 'via'는 '~을 통해', '~을 거쳐'라는 의미로 특히 접근 경로나 수단을 나타낼 때 사용됩니다. 이 문장에서는 보고서에 접근하는 방법이 회사의 내부 네트워크임을 나타냅니다.",
  },
  {
    id: 77,
    koreanChunks: [
      "회의가",
      "재스케줄되었다",
      "매니저가 가졌기때문에",
      "긴급출장을",
    ],
    englishChunks: [
      "The meeting",
      "was rescheduled",
      "because the manager had",
      "an urgent business trip",
    ],
    fullEnglish:
      "The meeting was rescheduled because the manager had an urgent business trip.",
    explanation: "",

    additionalExplanation:
      "뒤에 주어 , 동사 형태로 접속사입니다 주어+동사+접속사로 해석합니다. 매니저가 가졌기 때문에",
  },

  {
    id: 78,
    koreanChunks: [
      "날씨가 좋지 않았음에도 불구하고,",
      "야외 행사는",
      "진행되었습니다",
      "계획대로",
    ],
    englishChunks: [
      "Although the weather was unfavorable,",
      "the outdoor event",
      "continued ",
      "as planned",
    ],
    fullEnglish:
      "Although the weather was unfavorable, the outdoor event continued as planned.",
    explanation:
      "접속사 'Although'가 양보의 의미로 사용되었습니다. 'Although'는 '~에도 불구하고'라는 의미로 두 개의 대조되는 상황을 연결할 때 사용됩니다. 첫 번째 절은 부정적인 상황(좋지 않은 날씨)을 나타내고, 두 번째 절은 그럼에도 불구하고 발생한 일(행사 진행)을 나타냅니다.",
    additionalExplanation: "접속사는 뒤에 주어 동사 먼저 해석 후 연결",
  },
  {
    id: 79,
    koreanChunks: [
      "새로운 인턴이 부족함에도 불구하고",
      "경험이,",
      "그녀는",
      "배웁니다",
      "매우 빠르게",
    ],
    englishChunks: [
      "While the new intern lacks",
      "experience,",
      "she learns",
      "very quickly",
    ],
    fullEnglish:
      "While the new intern lacks experience, she learns very quickly.",
    explanation:
      "접속사 'While'이 양보의 의미로 사용되었습니다. 'While'은 '~에도 불구하고'라는 의미로 두 개의 대조되는 상황을 연결할 때 사용됩니다. 첫 번째 절은 부정적인 측면(경험 부족)을 나타내고, 두 번째 절은 긍정적인 측면(빠른 학습 능력)을 나타냅니다.",
    additionalExplanation:
      "뒤에 절 형태가 오는 것으로 보아 접속사입니다. 접속사에 주어+동사가 올 경우 주어 + 동사를 먼저 읽고 접속사의 의미를 말미에 붙입니다.  즉 여기서는 '새로운 인턴이 부족함에도 불구하고'라고 해석합니다.",
  },
  {
    id: 80,
    koreanChunks: [
      "만약 당신이 제출한다면",
      "보고서를",
      "12시까지",
      "그것은 포함될 것입니다",
      "발표에",
    ],
    englishChunks: [
      "If you submit",
      "the report",
      "by noon,",
      "it will be included",
      "in the presentation",
    ],
    fullEnglish:
      "If you submit the report by noon, it will be included in the presentation.",
    explanation:
      "접속사 'If'가 조건의 의미로 사용되었습니다. 'If'는 '만약 ~라면'이라는 의미로 조건과 결과를 연결할 때 사용됩니다. 첫 번째 절은 조건(정오까지 보고서 제출)을 나타내고, 두 번째 절은 그 조건이 충족될 경우의 결과(발표에 포함됨)를 나타냅니다.",
    additionalExplanation:
      "뒤에 절 형태가 오는 것으로 보아 접속사입니다. 접속사에 주어+동사가 올 경우 주어 + 동사를 먼저 해석한 후 접속사의 의미를 연결합니다. 즉 여기서는 '당신이 제출한다면'이라고 해석합니다.",
  },
];
